import { useWatch } from "react-hook-form";
import { useMemo } from "react";
import { CustomizableComponentConfiguration, commonSettings, fontSettings } from "../../../CustomComponents";

export function useQRandWebshopJamezzStylesComponentConfiguration(): CustomizableComponentConfiguration {
  const salesareaType = useWatch({ name: "salesarea_type" });
  const piggyEnabled = useWatch({ name: "piggy__use_loyalty" });
  const mwiseEnabled = useWatch({ name: "extra_settings__mwise_loyalty_enabled" });
  const arrangementsEnabled = useWatch({ name: "use_arrangements" });

  return useMemo(() => {
    let components: CustomizableComponentConfiguration = [];

    if (salesareaType !== "QR" && salesareaType !== "PICKUP_DELIVERY" && salesareaType !== "CATALOG") return components;

    if (piggyEnabled) {
      components = components.concat([
        {
          className: ".JS-ArticleContent-PiggyRewardBanner",
          label: "The banner shown when a product is also available as a piggy reward",
          values: {
            color: null,
            backgroundColor: null,
          },
        },
        {
          className: ".JS-PiggyLogin-Input",
          label: "Piggy login e-mail input",
          values: {
            color: null,
            backgroundColor: null,
          },
        },
        {
          className: ".JS-PiggyLogin-Input-Label",
          label: "Piggy login e-mail input label (description)",
          values: {
            color: null,
          },
        },
        {
          className: ".JS-PiggyLogin-Button",
          label: "Piggy login button",
          values: {
            color: null,
            backgroundColor: null,
          },
        },
        {
          className: ".JS-Piggy-Root",
          label: "Piggy loyalty root",
          values: {
            display: null,
          },
        },
        {
          className: ".JS-PiggyLoyalty-Button",
          label: "Piggy loyalty button",
          values: {
            backgroundColor: null,
            ...fontSettings,
          },
        },
        {
          className: ".JS-PiggyDialog-Root",
          label: "Piggy dialog page",
          values: {
            backgroundColor: null,
            color: null,
            fontSize: null,
            fontFamily: null,
            fontStyle: null,
            fontWeight: null,
          },
        },
        {
          className: ".JS-Piggy-LoyaltyHeader",
          label: "Header on piggy page",
          values: { fontFamily: null },
        },
        {
          className: ".JS-Piggy-RewardsHeader",
          label: "SubHeader on piggy page listing 'rewards'",
          values: { fontFamily: null },
        },
        {
          className: ".JS-Piggy-AccountHeader",
          label: "SubHeader on piggy page for the account",
          values: { fontFamily: null },
        },
      ]);
    }
    if (mwiseEnabled) {
      components = components.concat([
        {
          className: ".JS-MWiseRewards-CallToAction-Login",
          label: "Call to action on the mwise rewards to login",
          values: {
            backgroundColor: null,
            color: null,
            fontSize: null,
            fontFamily: null,
            fontStyle: null,
            fontWeight: null,
          },
        },
      ]);
    }
    if (arrangementsEnabled) {
      components = components.concat([
        {
          className: ".JS-ArrangementChip-Root",
          label: "Arrangements Overview Chip Root",
          values: {
            ...commonSettings,
          },
        },
        {
          className: ".JS-ArrangementChip-Box",
          label: "Arrangements Overview Chip Background",
          values: {
            ...commonSettings,
          },
        },
        {
          className: ".JS-ArrangementsOverview-Root",
          label: "Arrangements Overview",
          values: {
            ...commonSettings,
          },
        },
      ]);
    }

    components = components.concat([
      {
        className: ".JS-ArticleContent-PriceWrapper",
        label: "Article price wrapper",
        values: {
          color: null,
        },
      },
      {
        className: ".JS-OrderArticleSelectorPageContent-HeaderWrapper",
        label: "The top bar for the order article selector page",
        values: {
          color: null,
          backgroundColor: null,
        },
      },
      {
        className: ".JS-OrderArticleSelectorPage-CountChangeButton",
        label: "The + and - buttons for a product on the order article selector page",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OrderArticleSelectorPage-PlusButton",
        label: "The + button for a product on the order article selector page",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OrderArticleSelectorPage-MinusButton",
        label: "The - button for a product on the order article selector page",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OptionGroupContent-Header",
        label: "Header for the following option group",
        values: {
          backgroundColor: null,
          color: null,
        },
      },
      {
        className: ".JS-BackDialogButton-Icon",
        label: "The back button for a dialog",
        values: {
          color: null,
        },
      },
      {
        className: ".JS-BackDialogButton-Root",
        label: "The back button for a dialog",
        values: {
          backgroundColor: null,
        },
      },
      {
        className: ".JS-MenuContent-Root",
        label: "Background of a menu",
        values: {
          backgroundColor: null,
        },
        JSImage: [{ name: "qrv5_menu_content_background", res: "390x650" }],
      },
      {
        className: ".JS-OrderArticleSelectorPage-Root",
        label: "Background of an article page",
        values: {
          backgroundColor: null,
        },
        JSImage: [{ name: "qrv5_article_page_background", res: "390x844" }],
      },
      {
        className: ".JS-ReturnPage-Root",
        label: "Background of the return page",
        values: {
          backgroundColor: null,
        },
        JSImage: [{ name: "JS-ReturnPage-Root", res: "390x844" }],
      },
      {
        className: ".JS-AfterPayPage-BackgroundImage",
        label: "Background of the order page",
        values: {
          backgroundColor: null,
        },
        JSImage: [{ name: "qrv5_background_of_checkout_page", res: "390x844" }],
      },
      {
        className: ".JS-AfterPayPage-BackgroundImage",
        label: "Background of the order page",
        values: {
          backgroundColor: null,
        },
        JSImage: [{ name: "qrv5_background_of_order_page", res: "390x844" }],
      },
      {
        className: ".JS-OrderPage-BackgroundImage",
        label: "Background of the order page",
        values: {
          backgroundColor: null,
        },
        JSImage: [{ name: "qrv5_background_of_checkout_page", res: "390x844" }],
      },
      {
        className: ".JS-Image-BackgroundImage",
        label: "Background of the order page",
        values: {
          backgroundColor: null,
        },
        JSImage: [{ name: "qrv5_background_of_order_page", res: "390x844" }],
      },
      {
        className: ".JS-TopBar-LogoImage",
        label: "Logo image",
        JSImage: [{ name: "qrv5_logo_top_bar", res: "72x40" }],
      },
      {
        className: ".JS-MenuFilterDialog-Allergies",
        label: "Allergies container on the preferences dialog",
        values: {
          display: null,
        },
      },
      {
        className: ".JS-MenuTag-Allergens",
        label: "Container for allergens on article detail popup",
        values: {
          display: null,
        },
      },
      {
        className: ".JS-ArticleContent-Wrapper1",
        label: "Inner wrapper for an article",
        values: {
          backgroundColor: null,
          marginTop: null,
          marginBottom: null,
          marginRight: null,
          marginLeft: null,
          alignItems: null,
        },
      },
      {
        className: ".JS-ArticlegroupContent-Name-Container",
        label: "The containing element for the title (use for centering the text)",
        values: {
          justifyContent: null,
          position: null,
          ...commonSettings,
        },
      },
      {
        className: ".JS-MenuFilterDialog-Allergens-Subtext",
        label: "JS-MenuFilterDialog-Allergens-Subtext",
        values: { ...commonSettings },
      },
      {
        className: ".JS-MenuFilterDialog-Preference-Subtext",
        label: "JS-MenuFilterDialog-Preference-Subtext",
        values: { ...commonSettings },
      },

      {
        className: ".JS-OptionItemNameAndPrice-Name",
        label: "An option's text",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OptionItemNameAndPrice-Description",
        label: "An option's text",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OptionGroupContent-PleaseMakeAChoiceFeedback",
        label: "Please make a choice feedback when no options have been selected",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OrderArticleSelectorPage-AddToOrderButton",
        label: "Add to order button",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-SuperGroups-Root",
        label: "Drinks & food bar",
        values: {
          display: null,
          backgroundColor: null,
          borderBottom: null,
        },
      },
      {
        className: ".JS-ArticlegroupTabBar-Root",
        label: "Articlegroup tab bar",
        values: {
          display: null,
          backgroundColor: null,
          borderBottom: null,
        },
        JSImage: [{ name: "qrv5_list_of_menus_background", res: "390x48" }],
      },
      {
        className: ".JS-ArticleContent-ButtonBase",
        label: "The card showcasing a product on the menu",
        values: {
          ...commonSettings,
          backgroundRepeat: null,
          backgroundImage: null,
          backgroundSize: null,
          pointerEvents: null,
        },
      },
      {
        className: ".JS-OrderPage-ArticleCard",
        label: "The card holding an article",
        values: { backgroundColor: null },
      },
      {
        className: ".JS-OrderPage-ArticleCountValue",
        label: "How much this article appears in the cart, ie: 1",
        values: { ...commonSettings },
      },
      {
        className: ".JS-CheckoutPage-MinMaxOrderValueText",
        label: "Text when minimum order value is not reached, or maximum order value is exceeded",
        values: { ...commonSettings },
      },
      {
        className: ".JS-MenuPage-CategoryText",
        label: "Text for categories",
        values: { ...commonSettings },
      },
      {
        className: ".JS-MenuPage-CategoryText-selected",
        label: "Text for categories",
        values: { ...commonSettings },
      },
      { className: ".JS-QuickAddOrderButton-Root", label: "Quick plus/minus button", values: { ...commonSettings } },
      {
        className: ".JS-CheckoutPage-Header",
        label: "Primary header on checkout page",
        values: { ...commonSettings },
      },
      {
        className: ".JS-CheckoutPage-OrderItem",
        label: "Order item(s) on checkout page",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-CheckoutPage-OrderItem-Price",
        label: "Price of the order item",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-CheckoutPage-OrderItem-Name",
        label: "Name of the order item",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-CheckoutPage-OrderItem-OptionCount",
        label: "Count of the options belonging to an order item, only shows if more than 1x",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-CheckoutPage-OrderItem-OptionName",
        label: "Name(s) of the option(s) belonging to an order item on the checkout page",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-CheckoutPage-TermsAndConditions-Checkbox",
        label: "The checkbox for the terms and conditions",
        values: { color: null },
      },
      {
        className: ".JS-CheckoutPage-TermsAndConditions-Text",
        label: "Text for the terms and conditions (excluding the links)",
        values: { ...commonSettings },
      },
      {
        className: ".JS-CheckoutPage-Price",
        label: "Calculated total price on Checkout Page",
        values: { ...commonSettings },
      },
      {
        className: ".JS-CheckoutPage-Total",
        label: "The text 'Total', a label for the total price",
        values: { ...commonSettings },
      },
      {
        className: ".JS-CheckoutPage-TermsAndConditions",
        label: "Text for the terms and conditions links (set text decoration color to the same as color!)",
        values: { color: null, textDecorationColor: null },
      },
      {
        className: ".JS-ArticlegroupTabBar-Tab",
        label: "Articlegroup Tab Bar - Tab Item",
        values: { ...commonSettings },
      },
      {
        className: ".JS-OptionItemCountable-Image-Wrapper",
        label: "Image Wrapper",
        values: { ...commonSettings, height: null },
      },
      {
        className: ".JS-OptionItemRadio-Image-Wrapper",
        label: "Image Wrapper",
        values: { ...commonSettings, height: null },
      },
      {
        className: ".JS-OptionItemOptional-Image-Wrapper",
        label: "Image Wrapper",
        values: { ...commonSettings, height: null },
      },
      {
        className: ".JS-ArticlegroupTabBar-Tab-selected",
        label: "Articlegroup Tab Bar - Tab Item - Selected",
        values: { ...commonSettings },
      },
      {
        className: ".JS-ArticlegroupTabBar-Tab-not-selected",
        label: "Articlegroup Tab Bar - Tab Item - Not selected",
        values: { ...commonSettings },
      },
      {
        className: ".JS-ArticleContent-QuickAddOrderButton",
        label: "Article - QuickAddOrderButton",
        values: { ...commonSettings },
      },
      {
        className: ".JS-ArticleContent-QuickAddOrderButton-PlusIcon",
        label: "Article - QuickAddOrderButton - Plus Icon",
        values: { ...commonSettings, width: null, height: null },
      },
      {
        className: ".JS-ArticleContent-QuickAddOrderButton-MinusIcon",
        label: "Article - QuickAddOrderButton - Minus Icon",
        values: { ...commonSettings, width: null, height: null },
      },
      {
        className: ".JS-ArticleContent-QuickAddOrderButton-Count",
        label: "Article - QuickAddOrderButton - Count",
        values: { ...commonSettings },
      },
      {
        className: ".JS-MenuHeader-Root",
        label: "Header Table Number",
        values: {
          margin: null,
          padding: null,
          display: null,
        },
        JSImage: [{ name: "qrv5_menu_header", res: "390x200" }],
      },
      {
        className: ".JS-MenuHeader-TableText",
        label: "Header Table Number Text",
        values: { ...commonSettings },
      },
      {
        className: ".JS-WaitingTimeView-Root",
        label: "WaitingTimeView Root",
        values: { ...commonSettings },
      },
      {
        className: ".JS-WaitingTimeView-time",
        label: "WaitingTimeView time",
        values: { ...commonSettings },
      },
      {
        className: ".JS-WaitingTimeView-min",
        label: "WaitingTimeView min",
        values: { ...commonSettings },
      },
      {
        className: ".JS-JamezzShowOrderButton-Badge",
        label: "Badge for Floating action button",
        values: { ...commonSettings },
      },
      {
        className: ".JS-JamezzShowOrderButton-SpeedDial",
        label: "Floating Action Button",
        values: { backgroundColor: null },
      },
      {
        className: ".JS-JamezzShowOrderButton-SpeedDialAction",
        label: "Floating Actions",
        values: { backgroundColor: null, color: null },
      },
      {
        className: ".JS-OrderPage-OrderOrCheckoutButton",
        label: "Order page order or checkout button",
        values: {
          borderColor: null,
          ...commonSettings,
          width: null,
          height: null,
        },
      },
      {
        className: ".JS-OrderPage-ArticleMinusButton",
        label: "Order page article ordered count minus button",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OrderPage-ArticlePlusButton",
        label: "Order page article ordered count plus button",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-CheckoutPage-PayOrOrderButton",
        label: "Checkout page send or pay button",
        values: {
          borderColor: null,
          width: null,
          height: null,
          ...commonSettings,
        },
      },
      {
        className: ".JS-TopBar-AppBar",
        label: "Entire top bar",
        values: {
          ...commonSettings,
        },
        JSImage: [{ name: "qrv5_topbar_background", res: "390x60" }],
      },
      {
        className: ".JS-TopBar-MenuIcon",
        label: "Topbar Menu Icon",
        values: { color: null },
      },
      {
        className: ".JS-TopBar-ServiceIcon",
        label: "Topbar Service Icon",
        values: { color: null },
      },
      {
        className: ".JS-TopBar-Service-Text",
        label: "Topbar Service Text",
        values: { ...fontSettings },
      },

      {
        className: ".JS-OrderPage-Subtotal",
        label: "Subtotal label on order page",
        values: { ...commonSettings },
      },
      {
        className: ".JS-OrderPage-SubtotalValue",
        label: "Subtotal value (ie, € 8.00) on order page",
        values: { ...commonSettings },
      },
      {
        className: ".JS-ArticlegroupContent-Name",
        label: "Articlegroup Title",
        values: { ...commonSettings },
      },
      {
        className: ".JS-SideMenuDrawer-Root",
        label: "Side Menu",
        values: { ...commonSettings },
      },
      {
        className: ".JS-SideMenuDrawer-Header",
        label: "Side Menu | Header",
        values: { ...commonSettings },
      },
      {
        className: ".JS-SideMenuDrawer-Header-Content",
        label: "Side Menu | Header content",
        values: { ...commonSettings },
      },
      {
        className: ".JS-SideMenuDrawer-ListItem",
        label: "Side Menu | List item",
        values: { ...commonSettings },
      },
      {
        className: ".JS-SideDrawerMenu-ItemIcon",
        label: "Side Menu | Icon",
        values: { color: null },
      },
      {
        className: ".JS-ServiceBottomDrawer-Root",
        label: "Bottom Service Menu",
        values: { ...commonSettings },
      },
      {
        className: ".JS-ServiceBottomDrawer-ListItem",
        label: "Bottom Service Menu | List item",
        values: { ...commonSettings },
      },
      {
        className: ".JS-ShowOrderButton-Root",
        label: "Show order button",
        values: { ...commonSettings },
      },
      {
        className: ".JS-ShowOrderButton-Chip",
        label: "Show order button chip",
        values: { ...commonSettings },
      },
    ]);

    return components;
  }, [salesareaType, piggyEnabled, mwiseEnabled]);
}
